function Format(times, fmt) {
  var o = {
    'M+': new Date(times).getMonth() + 1, //月份
    'd+': new Date(times).getDate(), //日
    'h+': new Date(times).getHours(), //小时
    'm+': new Date(times).getMinutes(), //分
    's+': new Date(times).getSeconds(), //秒
    'q+': Math.floor((new Date(times).getMonth() + 3) / 3), //季度
    'S': new Date(times).getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)){
    fmt = fmt.replace(RegExp.$1, (new Date(times).getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (const k in o){
    if (new RegExp('(' + k + ')').test(fmt)){
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
}

export function formatTimeToStr(times, pattern) {
  var d = Format(times, 'yyyy-MM-dd hh:mm:ss');
  if (pattern) {
    d = Format(times, pattern);
  }
  return d.toLocaleString();
}
export function formatTime(times, pattern) {
  var d = Format(times, 'hh:mm:ss');
  if (pattern) {
    d = Format(times, pattern);
  }
  return d.toLocaleString();
}